// @ts-nocheck

import { unmimicAccount } from 'actions/adminActions';
import { setInitialAmountType, setPlans } from 'actions/optionsActions';
import { setIncludeProcessingFee, setSuccessInfo } from 'actions/paymentActions';
import { getPreferences } from 'actions/preferencesActions';
import { createBrowserHistory } from 'history';
import _ from 'lodash';
import { crmDict, siteInitialAmounts } from 'modules/constants';
import { getCookie } from 'modules/cookie';
import { sendGtmPixel } from 'modules/gtm';
import { campaignIgnoreSites, siteFallbackCampaignIdWhenMissingCid, stsFallbackCampaignIdWhenMissingCid } from 'modules/siteContents';
import { prepareAuth0Redirect } from 'modules/landingUrl';
import { buildSessionUtms, constructRedirectUri } from 'modules/utils';
import queryString from 'query-string';
import React, { Component, Suspense } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { connect, ConnectedProps } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import Footer from 'sharedComponents/Footer';
import Header from 'sharedComponents/Header';
import MimicState from 'sharedComponents/MimicState';
import ReceiptBanner from 'sharedComponents/ReceiptBanner';
import Spinner from 'sharedComponents/Spinner';
import SystemMessage from 'sharedComponents/SystemMessage';
import { getAccessToken } from 'slices/accessSlice';
// import { initAccountPreferences } from 'slices/accountSlice';
import { getRecaptchaToken, loadRecaptcha, setRecaptchaV2Token, setRecaptchaMode } from 'slices/recaptchaSlice';
import {
    getCampaigns, getStatusReasons, loadAppState, retrieveCustomer, retrieveRoles, saveAppState,
    setCrm, setProfileAuth0, setRecaptchaWhitelistKey, setUtms
} from 'slices/rootSlice';
import sbjs from 'sourcebuster';
import { recaptchaToken } from "modules/token";
import { layoutConfigs } from 'modules/constants'

const defaultCampaignIdFromLayout = (layout?: string) =>
  layout && layoutConfigs[layout]?.defaultCampaignId

const syncLayoutModePageClass = (layout?: string | string[]) => {
  const id = Array.isArray(layout) ? layout[0] : layout
  if (id) {
    document.documentElement.classList.add('layout-mode-page')
    document.body.classList.add('layout-mode-page')
  } else {
    document.documentElement.classList.remove('layout-mode-page')
    document.body.classList.remove('layout-mode-page')
  }
}

const StsLoginPrompt = ({ loginWithRedirect, initialUrlParams }) => (
  <div className="app-form-body">
    <div className="form-container">
      <form>
      <div className="center" style={{ padding: '2.5rem 0' }}>
        <p>Login to view your payment history.</p>
        <Button
          variant="primary"
          className="btn-action-secondary"
          onClick={() => {
            prepareAuth0Redirect(initialUrlParams || {})
            loginWithRedirect({
              authorizationParams: {
                screen_hint: 'login',
                redirect_uri: `${location.protocol}//${location.host}`,
              },
              appState: { redirectUri: '/payments' },
            })
          }}
        >
          Login
        </Button>
      </div>
      </form>
    </div>
  </div>
)

import Admin from './Admin';
import Donate from './Donate/Donate';
import DonateExpressTerminal from './DonateExpressTerminal';
import PaymentMethods from './PaymentMethods';
import Payments from './Payments';
import Preferences from './Preferences';
import Subscriptions from './Subscriptions';
import Success from './Success';
import Verify from './Verify';
import Attendees from './Attendees';

import type { RootState } from 'src/store'
import type { AppRouteProps } from 'src/types/app'

const customHistory = createBrowserHistory()

const mapState = ({ root, account, options, payment, access, charityRun, recaptcha, contact }: RootState, ownProps: AppRouteProps) => ({
  token: access.token,
  userRoles: root.userRoles,
  isAdmin: !!root.userRoles.find((r: {name:string}) => {
    return r.name === (ownProps.isPoweredSite ? `Admin ${ownProps.site}` : `Admin`)
  }),
  isAdminTerminal: !!root.userRoles.find((r: {name:string}) => {
    return r.name === (ownProps.isPoweredSite ? `Admin Terminal ${ownProps.site}` : `Admin Terminal`)
  }),
  mimicState: root.mimicState,
  guestId: root.guestId,
  email: account.contact.email,
  phone: account.contact.phone,
  loadingCustomer: root.loadingCustomer,
  loadingRoles: root.loadingRoles,
  receiptUrl: root.receiptUrl,
  donationAmount: options.donationAmount,
  donationType: options.donationType,
  successInfo: payment.successInfo,
  stripeTerminals: payment.stripeTerminals,
  crm: root.crm,
  utms: root.utms,
  campaigns: root.campaigns,
  recaptcha,
  charityRun, 
  campaignId: contact.campaignId,
  eventContent: _.get(root.campaigns.find(c => c.id === contact.campaignId), ['options', 'event', 'content']),
  hasEventRegistrations: root.hasEventRegistrations,
})

const actionCreators = {
  getAccessToken,
  retrieveCustomer,
  retrieveRoles,
  setUtms,
  setProfileAuth0,
  saveAppState,
  loadAppState,
  getCampaigns,
  getStatusReasons,
  getPreferences,
  // initAccountPreferences,
  setPlans,
  unmimicAccount,
  setInitialAmountType,
  setRecaptchaWhitelistKey,
  setIncludeProcessingFee,
  setSuccessInfo,
  setCrm,
  loadRecaptcha,
  getRecaptchaToken,
  setRecaptchaV2Token,
  setRecaptchaMode,
}

const connector = connect(mapState, actionCreators)
type AppProps = ConnectedProps<typeof connector> & AppRouteProps;

/**
 * Main App Router
 * 
 * Using React-Router-Dom, lazy loads with Suspense and React.Lazy. 
 * 
 */
class AppRouter extends Component<AppProps> {

  state = { customerLoaded: false } // Initial load
  /**
   * Called after the first render.
   */
  async componentDidMount() {
    const loginConfig = this.checkLogin()
    if (loginConfig) {
      prepareAuth0Redirect(this.props.initialUrlParams)
      return this.props.loginWithRedirect!({authorizationParams: loginConfig })
    }
    const {
      isAdmin,
      setUtms,
      setCrm,
      profileAuth0,
      setProfileAuth0,
      setRecaptchaWhitelistKey,
      loadAppState,
      getAccessTokenSilently,
      getAccessToken,
      isLoginRedirect, getCampaigns,
      getStatusReasons,
      retrieveRoles,
      getPreferences,
      initAccountPreferences,
      setInitialAmountType,
      initialUrlParams,
      setPlans,
      setIncludeProcessingFee,
      setSuccessInfo,
      loginWithRedirect,
      loginWithPopup,
      site,
      // token,
      // charityRun,
      recaptcha,
      loadRecaptcha,
      setRecaptchaMode,
    } = this.props
    customHistory.replace(customHistory.location.pathname + '?' + queryString.stringify(_.pick(initialUrlParams, [
      'utm_campaign', 'utm_medium', 'utm_source', 'utm_content', 'utm_term', 'term', 'amount', 'cid', 'sponsorship', 'layout',
    ])))
    sbjs.init({ domain: this.props.host.cookie.replace(/^\./, '') })
    setUtms(buildSessionUtms(sbjs.get, initialUrlParams))
    if (crmDict[site]) setCrm(crmDict[site])
    setProfileAuth0(profileAuth0)

    setPlans(
      initialUrlParams.optm || getCookie('optm'), 
      initialUrlParams.opty || getCookie('opty'), 
      initialUrlParams.opto || getCookie('opto'),
      initialUrlParams.optm_text || getCookie('optm_text'),
      initialUrlParams.opty_text || getCookie('opty_text'),
      initialUrlParams.opto_text || getCookie('opto_text'),
      initialUrlParams.optg_text || getCookie('optg_text'),
      initialUrlParams.amountm || getCookie('amountm'),
      initialUrlParams.amounty || getCookie('amounty'),
      initialUrlParams.amounto || getCookie('amounto'),
    )
    if (initialUrlParams.key) setRecaptchaWhitelistKey!(initialUrlParams.key)

    const layoutConfigForInit = initialUrlParams.layout ? layoutConfigs[initialUrlParams.layout] : null
    const layoutInitialType = layoutConfigForInit?.initialDonationType
    const urlShowTypes = (initialUrlParams.show || '').toLowerCase().split(',').filter(Boolean)
    const effectiveTerm = layoutInitialType || initialUrlParams.term || getCookie('term')
    const amountKey = `amount${effectiveTerm?.charAt(0)}`
    setInitialAmountType({ 
      amount: siteInitialAmounts[site]?.[effectiveTerm] || initialUrlParams[amountKey] || initialUrlParams.amount || getCookie(amountKey) || getCookie('amount'),
      type: effectiveTerm,
      onlyShowTypes: layoutConfigForInit?.onlyShowTypes || urlShowTypes,
    })
    
    loadAppState()
    if (profileAuth0) {
      if (isLoginRedirect) {
        sendGtmPixel({
          event: 'login_success',
          email: profileAuth0.email,
        })
      }
      setIncludeProcessingFee(false)

      getAccessToken()
        .then(() => retrieveRoles(site))
        // .then(() => getPreferences(getAccessTokenSilently))

      // initAccountPreferences()
    }
    else {
      if (location.pathname === '/payment_methods') {
        prepareAuth0Redirect(initialUrlParams)
        const loginOptions = { authorizationParams: {redirect_uri: `${location.protocol}//${location.host}/payment_methods`}}
        if (window.top !== window) {
          window.open(`${location.protocol}//${location.host}/login`, '_blank')
          return
        }
        loginWithRedirect(loginOptions)
      }
    }

    getStatusReasons(isAdmin)
    if (initialUrlParams.layout) {
      setRecaptchaMode('v2')
    }
    syncLayoutModePageClass(initialUrlParams.layout)
    loadRecaptcha()

    // Resolve CID with explicit priority:
    //   URL ?cid= > layout default > cookie > site fallback
    // Layout default wins over a stored cookie because all sites share a cookie
    // domain on localhost (and savethestorks.org); stale CIDs must not override
    // an explicit layout default.
    getCampaigns(
      initialUrlParams.cid ||
        defaultCampaignIdFromLayout(initialUrlParams.layout) ||
        (getCookie('cid') as string) ||
        siteFallbackCampaignIdWhenMissingCid[site] ||
        ''
    )

    if (initialUrlParams.success_debug) {
      setSuccessInfo({ message: `You have made a donation`, previousDonationCount: parseInt(initialUrlParams.success_debug) })
    }

    const redirectQuery = sessionStorage.getItem('redirectQuery')
    if (redirectQuery) {
      sessionStorage.removeItem('redirectQuery')
    }

    return {}
  }


  /**
   * Called after the component is updated in the DOM.
   * 
   * @param prevProps Props before state update
   */
  componentDidUpdate(prevProps: Readonly<AppProps>, prevState: Readonly<{}>, snapshot?: any): void {
    document.body.style.removeProperty('overflow')

    const { 
      retrieveCustomer, 
      profileAuth0, 
      initialUrlParams, 
      getStatusReasons,
      recaptcha,
      isAdmin,
      loadingCustomer,
      getAccessTokenSilently,
      campaignId,
      campaigns,
      eventContent,
      getAccessToken
    } = this.props
    
    const layoutConfig = (eventContent?.layoutExclusion || []).includes(initialUrlParams.layout) ? null : (layoutConfigs[initialUrlParams.layout] || null)
    // recaptcha status changed
    if (
      (
        (prevProps.recaptcha.status !== 'idle' && recaptcha.status === 'idle') ||
        (recaptcha.mode === 'v2')
      ) && 
      !loadingCustomer &&
      (!profileAuth0 || profileAuth0.email_verified || profileAuth0.sub.includes('sms'))) {
      const { aid: accountId, contactid: contactId } = initialUrlParams
      if (!this.state.customerLoaded) {
        getAccessToken().then(() => retrieveCustomer({ accountId, contactId, layoutConfig }))
        this.setState({ customerLoaded: true })
      }
    } else {
      getRecaptchaToken()
    }

    // admin status changed
    if (!prevProps.isAdmin && isAdmin) {
      getStatusReasons(true)
    }

    const parsedQueries = queryString.parse(location.search)
    syncLayoutModePageClass(parsedQueries.layout)
    // if (!campaignId && campaigns.length) {
    //   const defaultCampaign = campaigns.find(c => c.options?.setAsDefault)
    //   if (defaultCampaign) {
    //     parsedQueries.cid = defaultCampaign.id
    //   }
    // }

    customHistory.replace(location.pathname + '?' + queryString.stringify(_.pick(
      parsedQueries,
      [
      'utm_campaign', 'utm_medium', 'utm_source', 'utm_content', 'utm_term', 'term', 'amount', 'cid', 'sponsorship', 'layout',
    ])))

  }

  componentWillUnmount() {
    document.documentElement.classList.remove('layout-mode-page')
    document.body.classList.remove('layout-mode-page')
  }

  /**
   * Check Login
   * 
   * @returns login config or false
   */
  checkLogin() {
    const login = location.pathname.includes('/login')
    const signup = location.pathname.includes('/signup')
    const { initialUrlParams } = this.props
    const { email, phone, login_type = 'email' } = initialUrlParams

    if (login || signup) {
      const postLoginPath = this.props.site === 'STS' ? '/payments' : '/donate'
      const allowSignup = signup && this.props.site !== 'STS'
      const loginConfig = {
        redirectUri: constructRedirectUri(initialUrlParams, postLoginPath),
        screen_hint: allowSignup ? 'signup' : 'login',
        login_hint: '',
      }
      if (login_type === 'email') {
        loginConfig.login_hint = email || undefined
      }
      else if (login_type === 'phone') {
        loginConfig.login_hint = phone || undefined
        loginConfig.connection = 'sms'
      }

      return loginConfig
    }
    
    return false
  }

  /**
   * @returns JSX
   */
  render() {
    const login = location.pathname.includes('/login'), signup = location.pathname.includes('/signup')

    if (login || signup || 
      !this.props.recaptcha.ready || 
      this.props.loadingRoles) {
      return <div className="center"><Spinner /></div>
    }
    
    const {
      isAdmin,
      isAdminTerminal,
      saveAppState,
      guestId,
      email,
      getAccessTokenSilently,
      loadingCustomer,
      // loadingRoles,
      receiptUrl,
      loginWithRedirect,
      loginWithPopup,
      profileAuth0,
      // isLoginRedirect,
      mimicState,
      unmimicAccount,
      site,
      donationAmount,
      donationType,
      initialUrlParams,
      initialPath,
      successInfo,
      stripeTerminals,
      crm,
      utms,
      recaptcha,
      campaignId,
      eventContent,
      hasEventRegistrations,
    } = this.props
    const layoutConfig = (eventContent?.layoutExclusion || []).includes(initialUrlParams.layout) ? null : (layoutConfigs[initialUrlParams.layout] || null)
    const loggedInWithPhone = profileAuth0?.sub.startsWith('sms|')
    const routeParams = { getAccessTokenSilently, loginWithRedirect, loginWithPopup, initialUrlParams, layoutConfig, site, crm, isAdminTerminal, loggedInWithPhone }
    const stsPaymentsOnly = site === 'STS'
    const defaultRedirect = stsPaymentsOnly ? '/payments' : `/donate${location.search}`
    const stsLoginPrompt = (
      <StsLoginPrompt
        loginWithRedirect={loginWithRedirect}
        initialUrlParams={initialUrlParams}
      />
    )
    let routerSwitch
    

    if (profileAuth0 && !loggedInWithPhone && !profileAuth0.email_verified) {
      routerSwitch = (
        <Routes>
          <Route path="/verify" element={<Verify {...this.props} initialUrlParams={initialUrlParams} initialPath={initialPath} />} />
          <Route path="*" element={<Navigate to="/verify" replace />} />
        </Routes>
      )
    }
    else if (!profileAuth0) {
      if (stsPaymentsOnly) {
        routerSwitch = (
          <Routes>
            <Route path="*" element={stsLoginPrompt} />
          </Routes>
        )
      }
      else {
      routerSwitch = (
        <Routes>
          <Route path="/donate" element={
            <Donate 
              {...routeParams}
              {...this.props}
              guestMode={true}
            />
          }/>
          <Route path="/donate_express" element={
            <Donate 
              {...routeParams}
              {...this.props}
              flow="express"
              guestMode={true}
            />
          }/>
          <Route path="/payment_methods" element={<PaymentMethods {...this.props} {...routeParams} isAdmin={isAdmin} loggedIn={false} />} />
          { successInfo && <Route path="/success" element={<Success {...this.props} {...routeParams} />} /> }
          <Route path="/admin" element={<Admin {...this.props} {...routeParams} isAdmin={isAdmin} />} />
          <Route path="*" element={<Navigate to={defaultRedirect} replace />} />
        </Routes>
      )
      }
    }
    else if (profileAuth0.sub.includes('sms')) {
      if (stsPaymentsOnly) {
        routerSwitch = (
          <Routes>
            <Route path="*" element={stsLoginPrompt} />
          </Routes>
        )
      }
      else {
      routerSwitch = (
        <Routes>
          <Route path="/donate" element={<Donate {...this.props} {...routeParams} />} />
          <Route path="/donate_express" element={<Donate {...this.props} {...routeParams} flow="express" />} />
          { successInfo && <Route path="/success" element={<Success {...this.props} {...routeParams} />} /> }
          <Route path="*" element={<Navigate to={defaultRedirect} replace />} />
        </Routes>
      )
      }
    }
    else if (isAdminTerminal) {
      if (stsPaymentsOnly) {
        routerSwitch = (
          <Routes>
            <Route path="/payments" element={<Payments {...this.props} {...routeParams} isAdmin={isAdmin} />} />
            { crm === 'salesforce' ? <Route path="/preferences" element={<Preferences {...this.props} {...routeParams} email={email} />} /> : null }
            { hasEventRegistrations ? <Route path="/attendees" element={<Attendees {...this.props} {...routeParams} />} /> : null }
            <Route path="/admin" element={<Admin {...this.props} {...routeParams} isAdmin={isAdmin} />} />
            <Route path="*" element={<Navigate to={defaultRedirect} replace />} />
          </Routes>
        )
      }
      else {
      routerSwitch = (
        <Routes>
          <Route path="/donate" element={<DonateExpressTerminal {...this.props} {...routeParams} guestMode={true}/>} />
          <Route path="/donate_express" element={<Donate {...this.props} {...routeParams} flow="express" />} />
          { successInfo && <Route path="/success" element={<Success {...this.props} {...routeParams} />} /> }
          <Route path="*" element={<Navigate to={defaultRedirect} replace />} />
        </Routes>
      )
      }
    }
    else {
      routerSwitch = stsPaymentsOnly ? (
        <Routes>
          <Route path="/payments" element={<Payments {...this.props} {...routeParams} isAdmin={isAdmin} />} />
          { crm === 'salesforce' ? <Route path="/preferences" element={<Preferences {...this.props} {...routeParams} email={email} />} /> : null }
          { hasEventRegistrations ? <Route path="/attendees" element={<Attendees {...this.props} {...routeParams} />} /> : null }
          <Route path="/admin" element={<Admin {...this.props} {...routeParams} isAdmin={isAdmin} />} />
          <Route path="*" element={<Navigate to={defaultRedirect} replace />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/donate" element={<Donate {...this.props} {...routeParams} />} />
          <Route path="/donate_express" element={<Donate {...this.props} {...routeParams} flow="express" />} />
          <Route path="/subscriptions" element={<Subscriptions {...this.props} {...routeParams} />} />
          <Route path="/payments" element={<Payments {...this.props} {...routeParams} isAdmin={isAdmin} />} />
          <Route path="/payment_methods" element={<PaymentMethods {...this.props} {...routeParams} isAdmin={isAdmin} />} />
          { successInfo && <Route path="/success" element={<Success {...this.props} {...routeParams} />} /> }
          { crm === 'salesforce' ? <Route path="/preferences" element={<Preferences {...this.props} {...routeParams} email={email} />} /> : null }
          { hasEventRegistrations ? <Route path="/attendees" element={<Attendees {...this.props} {...routeParams} />} /> : null }
          <Route path="/admin" element={<Admin {...this.props} {...routeParams} isAdmin={isAdmin} />} />
          <Route path="*" element={<Navigate to={defaultRedirect} replace />} />
        </Routes>
      )
    }

    return (
      <>
        <Header 
          {...this.props}
          saveAppState={saveAppState} 
          guestId={guestId} 
          email={email} 
          isAdmin={isAdmin} 
          donationType={donationType}
          donationAmount={donationAmount}
          search={window.location.search}
          pathname={window.location.pathname}
          successInfo={successInfo}
          isAdminTerminal={isAdminTerminal}
          utmCampaign={_.get(utms, ['current', 'cmp'], '')}
          initialUrlParams={initialUrlParams}
          layoutConfig={layoutConfig}
        />
        <MimicState 
          state={mimicState}
          unmimicAccount={unmimicAccount} 
          getAccessTokenSilently={getAccessTokenSilently}
          isAdmin={isAdmin}
          layoutConfig={layoutConfig}
        />
        {/* { 
          (receiptUrl && (site !== 'FEW')) ? (
            <ReceiptBanner
              receiptHost={this.props.host.receipts}
              receiptUrl={receiptUrl}
              layoutConfig={layoutConfig}
            />
          ) : null
        } */}
        <SystemMessage />
        {
          loadingCustomer === 'sync' ? (
            <Modal show={true} className={`modal-center modal-${site}`}>
              <Modal.Body>
                <div>
                  <span>Please wait for your account to be synchronized..</span>
                  <span className="fa fa-spinner fa-pulse float-right"/>
                </div>
              </Modal.Body>
            </Modal>
          ) : null
        }
        <Suspense fallback={<Spinner />}>
          { routerSwitch }
        </Suspense>
        <Footer 
          site={site} 
          isAdminTerminal={isAdminTerminal} 
          stripeTerminals={stripeTerminals} 
          guestMode={!profileAuth0} 
          initialUrlParams={initialUrlParams}
          layoutConfig={layoutConfig}
        />
      </>
    )
  }
}

export default connector(AppRouter)
